<template>
  <div class="cardFactors" :class="customClass">
      <img :src="require(`../../assets/${src}`)" v-if="src"/>
      <h3 class="cardFactors__title" v-html="title"></h3>
      <div class="cardFactors__text">{{ description }}</div>
  </div>
</template>
<script>
export default {
  name: "CardFactors",
  props: {
    src:{
      type: String
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    customClass: {
      type: String,
    },
  },

};
</script>